import React, {useContext, useEffect, useState} from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import {Toaster, toast} from "react-hot-toast";
import ajaxLogs from "../../util/remote/ajaxLogs";
import Loader from "../../Components/Common/Loader";

function TenantUnitsLogs() {
  const [propertyLog, setPropertyLog] = useState("");
  const [loading, setLoading] = useState(false);

  const PropertiesLogs = async () => {
    const server_response = await ajaxLogs.fetchTenantUnitsErrorLogs();
    if (server_response.status === "OK") {
      setPropertyLog(server_response.details);
    } else if (server_response.status === "Fail") {
      setPropertyLog("404");
    }
  };
  const handlePropertyResend = async () => {
    const server_response = await ajaxLogs.reCreateTenantUnitFromLog();
    if (server_response.status === "OK") {
      toast.success(server_response.message);
    } else if (server_response.status === "Fail") {
      toast.error(server_response.message);
    }
  };

  useEffect(() => {
    PropertiesLogs();
  }, []);

  return (
    <div>
      <AppContainer title="Tenants unit  generation paymentcode error log">
        <Toaster position="top-center" reverseOrder={false} />
        <div class="row">
          <div class="col-lg-12">{loading ? <Loader /> : ""}</div>
          <div class="col-lg-12">
            <h6 class="card-title mb-4 d-flex justify-content-end">
              <button
                onClick={handlePropertyResend}
                class="btn ripple btn-success btn-with-icon btn-sm">
                <i className="fa fa-file-export" /> Resend Creation Requests
              </button>
            </h6>
            <div class="card custom-card">
              <div class="card-body">
                <div>
                  <h6 class="card-title ">Tenants payments List</h6>
                </div>
                <div class="table-responsive">
                  <table
                    id="example3"
                    class="table table-striped table-hover table-bordered text-nowrap">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Tenant_unit_id</th>
                        <th>Tenant_name </th>
                        <th>Unit_name</th>
                        <th>agreedAmount</th>
                        <th>property_name</th>
                        <th>Date created_at</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(propertyLog) &&
                        propertyLog.map((item, key) => (
                          <>
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{item.tenant_unit_id}</td>
                              <td>{item.tenant_name}</td>
                              <td>{item.unit_name}</td>
                              <td>{item.agreedAmount}</td>
                              <td>{item.property_name}</td>
                              <td>{item.created_at.when}</td>
                              {/* <td>
                                <Link
                                  className="btn btn-outline-success w-100"
                                  to={`/tenants/tenant-profile/1`}>
                                 
                                  View Profile
                                </Link>
                              </td> */}
                            </tr>
                          </>
                        ))}
                      {propertyLog == "404" && (
                        <>
                          <tr>
                            <td colSpan={6} className="text-center text-info">
                              No data available here
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AppContainer>
    </div>
  );
}

export default TenantUnitsLogs;
